import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import EventEmitter, {
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { formatVal } from '../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../utils/common'
import classes from './index.module.scss'

export const Score = ({
  score,
  icon,
  color,
  appendStyle,
  styleIcon,
  disableNeedUpgrade,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const onClick = () => {
    if (disableNeedUpgrade) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  return (
    <Element
      className={classes.container}
      style={{ backgroundColor: color, ...appendStyle }}
      onClick={onClick}
    >
      {disableNeedUpgrade ? (
        <Icon className="icon-lock" color="#3A414B" />
      ) : (
        <span>
          {score !== null && score !== undefined && score !== ''
            ? formatVal(score, locale, false, 0)
            : EMPTY_VALUE}
        </span>
      )}

      {icon && (
        <Icon
          className={`icon-${icon}`}
          style={{
            cursor: 'default',
            fontSize: 8,
            marginLeft: 6,
            ...styleIcon,
          }}
        />
      )}
    </Element>
  )
}

Score.propTypes = {
  score: PropTypes.number,
  icon: PropTypes.string,
  color: PropTypes.string,
  appendStyle: PropTypes.object,
  styleIcon: PropTypes.object,
}
